import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentDuplicate from 'material-ui/svg-icons/content/content-copy';

const styles = {
    icon: {overflow: 'inherit'},
};

const DuplicateButton = ({basePath = '', record = {}}) => (
    <IconButton
        containerElement={<Link
            to={`${basePath}/create?duplicate=${(record) ? record.id : ''}&type=${encodeURIComponent((record) ? record.type : '')}`}/>}
        style={styles.icon}
    >
        <ContentDuplicate color={FuseTheme.palette.primary1Color}/>
    </IconButton>
);

DuplicateButton.propTypes = {
    basePath: PropTypes.string,
    record: PropTypes.object,
};

DuplicateButton.defaultProps = {
    style: {padding: 0},
};

export default DuplicateButton;



// WEBPACK FOOTER //
// ./src/Fuse/buttons/DuplicateButton.js